// Standard library imports
import React, { useEffect, useState } from 'react';
import _ from 'lodash';

// External library imports
import { toast } from 'react-toastify';

// Internal module imports
import Typography from '../../../../components/Typography/Typography';
import Table from '../../../../components/Table/Table';
import { useLoader } from '../../../../hooks';
import classes from '../../../../styles/AllDevices.module.css';
import CreateOnboardingForm from './ModalComponent/CreateOnboardingForm';
import ModalComponent from '../../../../components/ModalComponent/ModalComponent';
import { UilTrash, UilEye, UilPen, UilCheckCircle } from '@iconscout/react-unicons';
import IconComponent from '../../../../components/Icon/Icon';
import adminClasses from '../Admin.module.css';
import DeleteModal from '../../../../components/DeleteModal/DeleteModal';
import { RootOnboardingService } from '../../../../services/OnboardingService';
import FilterBarClasses from '../../../../styles/Filterbar.module.css';
import { DropdownComponent } from '../../../../components/Inputs/Input';
import { AdminService } from '../../../../services/AdminService';
import { momentTimeFormater } from '../../../../utils/dateHelper';

const Onboarding = () => {
    const [startLoader, stopLoader] = useLoader();
    const [modal, setModal] = useState({ status: false, data: null, onlyView: false });
    const [data, setData] = useState([]);
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        id: '',
    });
    const [approveModal, setApproveModal] = useState({
        status: false,
        id: '',
    });
    const [admins, setAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState({ label: 'All', value: 'all' });

    useEffect(() => {
        getAdmins();
    }, []);

    const getAdmins = () => {
        AdminService.ReadAll(startLoader, handleAdminSuccess, handleError, stopLoader);
    };

    const handleAdminSuccess = ({ data }) => {
        let temp = [{ label: 'All', value: 'all' }];
        data.data.map((e) => {
            temp.push({ label: e.name, value: e._id });
        });
        setAdmins(temp);
    };

    useEffect(() => {
        if (selectedAdmin?.value) getData();
    }, [selectedAdmin?.value]);

    const getData = () => {
        const params = { adminId: selectedAdmin.value };
        RootOnboardingService.GetAll(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleApprove = (id) => {
        const payload = {
            id: id,
        };
        RootOnboardingService.UpdateStatus(payload, startLoader, handleUpdateStatusSuccess, handleError, stopLoader);
    };

    const handleUpdateStatusSuccess = () => {
        toast.success('Status Updated Successfully');
        setApproveModal({ status: false, id: '' });
        getData();
    };

    const handleSuccess = ({ data }) => {
        const processed = _.get(data, ['data'], []).map((item, idx) => {
            return {
                ...item,
                sno: idx + 1,
                companyName: _.get(item, ['companyDetails', 'companyName']),
                contactName: _.get(item, ['contactDetails', 'name']),
                primaryEmail: _.get(item, ['contactDetails', 'primaryEmail']),
                status: item.status,
                partner: item?.adminId?.name || '',
                date: momentTimeFormater(item?.createdAt).format('YYYY-MM-DD'),
                action: (
                    <div className={adminClasses.ActionContainer}>
                        <div onClick={() => setApproveModal({ status: true, id: item._id })}>
                            <IconComponent icon={UilCheckCircle} tooltip={'Approve'} />
                        </div>
                        <div onClick={() => setModal({ status: true, data: item, onlyView: true })}>
                            <IconComponent icon={UilEye} tooltip={'View'} />
                        </div>
                        <div onClick={() => setModal({ status: true, data: item, onlyView: false })}>
                            <IconComponent icon={UilPen} tooltip={'Edit'} />
                        </div>
                        <div onClick={() => setDeleteModal({ status: true, id: item._id })}>
                            <IconComponent icon={UilTrash} tooltip={'Delete'} />
                        </div>
                    </div>
                ),
            };
        });

        setData(processed);
    };

    const handleDelete = () => {
        RootOnboardingService.Delete(deleteModal.id, startLoader, handleDeleteSuccess, handleError, stopLoader);
    };

    const handleDeleteSuccess = () => {
        toast.success('Form Deleted Successfully');
        getData();
    };

    const handleError = (err) => {
        toast.error(err?.response?.data?.message);
    };

    return (
        <div>
            <div className={FilterBarClasses.ParentWrapper}>
                <div className={FilterBarClasses.Left}>
                    <div className={FilterBarClasses.Filter}>
                        <label>Admins</label>
                        <div style={{ width: '10vw' }}>
                            <DropdownComponent defaultValue={selectedAdmin} options={admins} onChange={(e) => setSelectedAdmin(e)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content="Onboarding Forms" />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={data?.length} />
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <Table
                        head={['S.No', 'Company Name', 'Contact Name', 'Primary Email', 'Status', 'Partner', 'Submission date', 'Action']}
                        keys={['sno', 'companyName', 'contactName', 'primaryEmail', 'status', 'partner', 'date', 'action']}
                        data={data}
                    />
                </div>
                <div>
                    {modal.status && (
                        <ModalComponent isOpen={modal.status} setOpen={() => {}}>
                            <div>
                                <CreateOnboardingForm editData={modal.data} onlyView={modal?.onlyView} setModal={setModal} getData={getData} />
                            </div>
                        </ModalComponent>
                    )}

                    <DeleteModal
                        deletefunction={handleDelete}
                        opendeleteModal={deleteModal.status}
                        setOpenDeleteModal={(status) => setDeleteModal({ ...deleteModal, status })}
                    ></DeleteModal>
                    <DeleteModal
                        deletefunction={handleApprove}
                        opendeleteModal={approveModal.status}
                        setOpenDeleteModal={(status) => setApproveModal({ ...approveModal, status })}
                        title="Approve Onboarding Request ?"
                        yesButtonText="Approve"
                        noButtonText="Cancel"
                        text="This will approve the onboarding request."
                        deviceId={approveModal.id}
                    ></DeleteModal>
                </div>
            </div>
        </div>
    );
};

export default Onboarding;
